import React,{Component} from 'react';
import {connect} from 'react-redux';
import * as actions from './../../actions';
import {Link} from 'react-router';
import $ from 'jquery';

export  class AboutHeader extends Component{
	constructor(props){
		super(props);
		this.state={
      status: '',
			keyword: '',
		};
this.test=this.test.bind(this);
	}

test(type)
{
// console.log(type);
}


	onFocus(event){
    this.setState({
      status: 'foucs',
      keyword: event.target.value
    })
  }
  onChangeKey(event){
    this.props.search_products(event.target.value);
    this.setState({
      keyword: event.target.value
    })
  }

  onBlur() {  
    this.setState({
      status: 'unfocus'
    })
  }
  resetKey(){
    this.props.search_products('');
    this.setState({
      keyword:'',
    });
  }


componentWillUnmount(){
    this.props.clear_state();    
  }
 


render(){  
$(document).on('mouseup',function (e)
{
    var container = $('.search');
    var container_sub = $('.res');

    if (!container.is(e.target) // if the target of the click isn't the container...
        && container.has(e.target).length === 0) // ... nor a descendant of the container
    {
        container_sub.hide();
    }else{
    	container_sub.show();
    }
}); 
  if(this.props.brands.length > 0 ){ var brands = (<h5 className="brand_hdr">Brands</h5>)} 
  if(this.props.products.length > 0 ){ var products = (<h5 className="brand_hdr">Products</h5>)}  
  var brands_list=this.props.brands.map(function(brand,index){
      // var link = this.props.params.Type;
        return(
            <li key={index}>
              <a style={{textDecoration: 'none'}} className="brand_tlt" href={"/pdeals/"+brand.id +"/"+brand.type+"/"+brand.dtype} >
              {brand.category_name}
              </a>
            </li>
         )
       }) ; 
  var product_list=this.props.products.map(function(product,index){
      // var link = this.props.params.Type;
        return(
            <li key={index}>
              <a className="brand_tlt" href={"/subdeals/"+product.id+"/"+product.dtype} onClick={()=>{this.test("/subdeals/"+product.id+"/"+product.dtype)}}>
              {product.category_name}
              </a>
            </li>
         )
       }.bind(this)) ; 

 
		return(
       <div className="web_deals">
          {/* <!-- header start --> */}
         <section className="indx_hdr hm_hdr">
          {/*  <!-- nav start --> */}
            <div className="inx_nav">
              <nav className="navbar navbar-default">
                <div className="container">
                  <div className="row">
                      <div className="col-md-2 col-sm-3 col-xs-6">
                        <Link className="navbar-brand ad_logo about_adlogo" to={"/web/home"}> <img src={'https://aquadeals.in/admin/assets/images_web/logo.png'} title="AquaDeals" alt="AquaDeals" /><span>#HappyFarming</span></Link>
                      </div>
                      <div className="col-md-3 col-sm-4 col-xs-6 pull-right"> 
                        <ul className="nav navbar-nav navbar-right">
                           <li><a href="https://play.google.com/store/apps/details?id=com.aquadeals.user&hl=en" target="_blank" title="" className="play_img"><img src={'https://aquadeals.in/admin/assets/images/web_imgs/google_play_store_icon.png'} alt="download" title="Download AquaDeals Mobile App" /></a></li>
                        </ul>
                      </div>
                      <div className="col-md-6 col-md-offset-1 col-sm-12 col-xs-12">
                      </div>
                   </div>
                </div> {/* <!-- /.container-fluid --> */}
              </nav>
              {/* test */}
              <div className="res" style={{maxWidth:'550px',maxHeight:'400px',position:'absolute',left:0,overflowX:'hidden',overflowY:'scroll',margin:'0 auto',textDecoration:'none',right: 0,top:'57px',display:'none'}}>
                <div>{brands}</div>
                    <ul style={{paddingLeft : 15+'px'}}>
                       {brands_list}
                    </ul>
                    <div>{products}</div>
                    <ul style={{paddingLeft : 15+'px'}}>
                       {product_list}
                    </ul>
                </div>
                {/*test end */}
              </div>
                {/* <!-- nav end --> */}
                <div className="clr">&nbsp;</div>
                <div className="clr">&nbsp;</div>
                <div className="clr">&nbsp;</div>
        </section>
                {/* <!-- header end --> */}
     </div>
    );
  }
}
function mapStateToProps(state){
    return {
        search:state.posts.search,
        brands:state.posts.brands,
        products:state.posts.products,
        trendings:state.posts.trendings
    }
}

export default connect(mapStateToProps,actions)(AboutHeader);



/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Common/AboutHeader.js
 **/